import React from 'react';
import "./Jobcard.css";
import Sidebar from '../../Component/sidebar/sidebar';
import Header from '../../Component/header/Header';
import Search from "../../Component/sub-jobcard/Search";

function Home() {
  return (
    <div className="container">
      <div className="row row-cols-2">
        {/* SIDEBAR DESIGN */}
        <div className="col-2 sidebar">
            <Sidebar />
        </div>

        {/* CONTENT DESIGN */}
        <div className="col-10 content">
          <Header title={"Activites"}/>
          {/* search section */}
          <Search />
        </div>
      </div>
    </div>
  );
}

export default Home;